<div class="growl-container__icon">
	<ta-icon *ngIf="notice.icon != null" [icon]="notice.icon"></ta-icon>
</div>
<div class="growl-container__message">
	{{ notice.message }}
</div>
